<template>
  <div class="RejoinSessionModal">
    <h1 class="RejoinSessionModal-title">
      {{ $t('app.appModal.rejoinSessionModal.title') }}
    </h1>
    <h2 class="RejoinSessionModal-subtitle">
      {{ $t('app.appModal.rejoinSessionModal.subtitle') }}
    </h2>

    <div class="RejoinSessionModal-buttons">
      <large-button primary @click.native="rejoin">{{
        $t('app.appModal.rejoinSessionModal.ReturnButton')
      }}</large-button>
      <large-button secondary @click.native="end">{{
        $t('app.appModal.rejoinSessionModal.endButton')
      }}</large-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as sessionUtils from '@/utils/session'
import LargeButton from '@/components/LargeButton.vue'

export default {
  components: { LargeButton },
  computed: {
    ...mapGetters({
      mobileMode: 'app/mobileMode',
      sessionPath: 'user/sessionPath',
      isRecapSocketUpdatesActive: 'featureFlags/isRecapSocketUpdatesActive',
    }),
  },
  watch: {
    // Hide modal if mobileMode becomes false
    mobileMode(value) {
      if (!value) this.$store.dispatch('app/modal/hide')
    },
  },
  methods: {
    rejoin() {
      sessionUtils.rejoinSession(this.$router, this.sessionPath)
    },
    end() {
      sessionUtils.endSession(this, this.isRecapSocketUpdatesActive)
    },
  },
}
</script>

<style lang="scss" scoped>
h1,
h2,
p {
  margin: 0;
  padding: 0;
}

.RejoinSessionModal {
  @include flex-container(column);
  @include child-spacing(top, 16px);
}

.RejoinSessionModal-title {
  @include font-category('display-small');
}

.RejoinSessionModal-subtitle {
  @include font-category('body');
  color: $c-secondary-grey;
}

.RejoinSessionModal-buttons {
  @include flex-container(column);
  @include child-spacing(top, 16px);
  margin-top: 40px;
}
</style>
